import { defaultZodCatch } from '@/lib/converters/defaultZodCatch'
import { discountRowTypeEnumConverter } from '@/lib/converters/discountRowTypeEnum/discountRowTypeEnumConverter'
import { zDiscountApplied } from '@/schemas/discountAppliedSchema'

import type { DiscountAppliedDto as ResponseDto } from '@/gen/bff'
import type { SILDiscountApplied } from '@/gen/ecom'
import type { DiscountAppliedSchema } from '@/schemas/discountAppliedSchema'

export const discountAppliedConverter = (data: ResponseDto | SILDiscountApplied): DiscountAppliedSchema => {
  const response: DiscountAppliedSchema = {
    id: data.id ?? '',
    percentage: data.percentage ?? 0,
    fixPrice: data.fixPrice ?? null,
    minimumQuantityNeeded: data.minimumQuantityNeeded ?? 0,
    minimumApplicableQuantity: data.minimumApplicableQuantity ?? null,
    quantityOrdered: data.quantityOrdered ?? 0,
    discountSourceId: data.discountSourceId ?? null,
    startDate: data.startDate?.toLocaleString() ?? null,
    endDate: data.endDate?.toLocaleString() ?? null,
    discountType: discountRowTypeEnumConverter(data.discountRowType),
    isNettable: data.isNettable ?? false,
    isApplied: data.isApplied ?? false,
  }

  return zDiscountApplied.catch(defaultZodCatch).parse(response)
}
